export default __webpack_public_path__ + "static/media/proccessing.8fc01845.svg";